import api from '../lib/api';
import type { Paginated } from '../types';
import type { Goal, GoalInput } from '../types/crm';

// Single-record endpoints (show/create/update) return a JSON:API-style envelope:
// `{ data: { id, type, attributes: {...flat record...} } }`. List endpoints return
// flat records directly inside `data`. Mirrors operator.service.ts.

export const goalService = {
  getAll: async (params?: Record<string, unknown>): Promise<Paginated<Goal>> => {
    const response = await api.get<Paginated<Goal>>('/goals', { params });
    return response.data;
  },

  getById: async (id: number): Promise<Goal> => {
    const response = await api.get<{ data: { attributes: Goal } }>(`/goals/${id}`);
    return response.data.data.attributes;
  },

  create: async (data: GoalInput): Promise<Goal> => {
    const response = await api.post<{ data: { attributes: Goal } }>('/goals', { goal: data });
    return response.data.data.attributes;
  },

  update: async (id: number, data: Partial<GoalInput>): Promise<Goal> => {
    const response = await api.patch<{ data: { attributes: Goal } }>(`/goals/${id}`, {
      goal: data,
    });
    return response.data.data.attributes;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/goals/${id}`);
  },
};

export default goalService;
